<script>
  // Logic
  import { onMount } from "svelte";
  import { getVaccination, getCases, getSUS } from "../utils/apiNew";
  import {getPercentage, numberWithSpaces} from '../utils/utils';
  
  // Components
  import Progress from "./Progress.svelte";

  // Bindings
  $: vaksinedata = { befolkning: '-', full: '-', half: '-' };
  $: susLast = { hospitalized: '-', deaths: '-', respirator: '-' };
  $: cases = {total: '-', yesterday: '-'}; 
  const articles = [
      { title: 'Direkte', url: 'i/naK75a' },
      { title: 'Siste', url: 'tag/koronaviruset' },
      { title: 'Regler', url: 'i/aPPmkE' }
    ];

  onMount(async () => {
    // Vaksinedata
    const vaxdata = await getVaccination();
    vaksinedata = summerVakinerteRogaland(vaxdata);
    
    // Tall fra SUS
    const susData = await getSUS();
    susLast = susData.last;
    
    // MSIS-data
    const msis = await getCases();
    cases = {total: msis.total, yesterday: msis.totalYesterday};    
  });

  const summerVakinerteRogaland = (vaksinedata) => {
    return vaksinedata.reduce(
      (acc, curr) => {
        return {
          one: acc.one + curr.dose1,
          two: acc.two + curr.dose2,
          three: acc.three + curr.dose3,
          befolkning: acc.befolkning + curr.befolkning,
        };
      },
      {
        befolkning: 0,
        one: 0,
        two: 0,
        three: 0,
      }
    );
  };

  const formateDate = (date) => {
    const currentDate = new Date(date);
    return (
      ("0"+currentDate.getDate()).slice(-2) +
      "." +
      ("0" + (currentDate.getMonth() + 1)).slice(-2) +
      "." +
      currentDate.getFullYear()
    );
  };
</script>

<article class="sa-koronastripe-v2">
  <section class="row top">
    <div class="row-scroll top">
      <div class="col">
        <h3 class="title">Korona</h3>
      </div>
      <div class="col group-right">
          {#each articles as link}
            <div class="col col-link">
            <a href='https://aftenbladet.no/{link.url}' class="link" target="_top">{link.title}</a>
            </div>
        {/each}
      </div>
    </div>
  </section>
   <section class="row stat">
    <a href="https://aftenbladet.no/i/4q8WxR/?ref=stripa" target="_top" class="row-scroll fade-right">
      <div  class="col stat">
        <p class="title">SUS</p>
        <p class="subtitle">Sist oppdatert {susLast.imported ? formateDate(susLast.imported) : '-'}</p>
        <div class="row">
          <div class="row center">
            <p class="value">{susLast.hospitalized}</p>
            <p class="label">innlagte</p>
          </div>
          <div class="row center">
            <p class="value">{susLast.respirator}</p>
            <p class="label">på respirator</p>
          </div>
          <div class="row center">
            <p class="value">{susLast.deaths}</p>
            <p class="label">døde</p>
          </div>
        </div>
      </div>
      <div class="col stat">
        <p class="title">Vaksinering i Rogaland</p>
        <Progress
          max={vaksinedata.befolkning}
          values={[vaksinedata.one,vaksinedata.two, vaksinedata.three]}
        />

        <div class="row">
          <div class="row center">
            <p class="value">
              {vaksinedata.befolkning != "-" ? getPercentage(vaksinedata.three, vaksinedata.befolkning) : '- '}%
            </p>
            <p class="label">tredje dose</p>
          </div>
          <div class="row center">
            <p class="value">
              {vaksinedata.befolkning != "-" ? getPercentage(vaksinedata.two, vaksinedata.befolkning) : '- '}%
            </p>
            <p class="label">andre dose</p>
          </div>
          <div class="row center">
            <p class="value">
              {vaksinedata.befolkning != "-" ? getPercentage(vaksinedata.one, vaksinedata.befolkning) : '- '}%
            </p>
            <p class="label">minst én dose</p>
          </div>
        </div>
      </div>
    
      <div class="col stat">
        <p class="title">Smitte </p>
        <p class="subtitle">i Rogaland</p>
        <div class="row">
          <div class="row center">
            <p class="value">{cases.yesterday}</p>
            <p class="label">nye i går</p>
          </div>
          <div class="row center">
            <p class="value">{numberWithSpaces(cases.total)}</p>
            <p class="label">totalt</p>
          </div>
        </div>
      </div>
      <div class="col stat center group-right">
            <a class="link link-btn" target="_top" href="https://aftenbladet.no/i/4q8WxR">
                <svg class="icon" viewBox="0 0 79.935 79.935" x="0px" y="0px" fill-rule="evenodd" clip-rule="evenodd">
                    <path class="fil0" d="M54.073 9.405c-2.597,0 -4.703,-2.106 -4.703,-4.703 0,-2.596 2.106,-4.702 4.703,-4.702l21.16 0c2.595,0 4.702,2.108 4.702,4.702l0 21.161c0,2.596 -2.106,4.702 -4.702,4.702 -2.596,0 -4.702,-2.106 -4.702,-4.702l0 -9.81 -27.239 27.239c-1.836,1.835 -4.813,1.835 -6.649,0 -1.835,-1.836 -1.835,-4.813 0,-6.649l27.239 -27.238 -9.809 0zm16.458 35.265c0,-2.597 2.106,-4.702 4.702,-4.702 2.596,0 4.702,2.105 4.702,4.702l0 30.563c0,2.596 -2.106,4.702 -4.702,4.702l-70.531 0c-2.596,0 -4.702,-2.106 -4.702,-4.702l0 -70.531c0,-2.596 2.106,-4.702 4.702,-4.702l30.563 0c2.597,0 4.703,2.106 4.703,4.702 0,2.597 -2.106,4.703 -4.703,4.703l-25.86 0 0 61.126 61.126 0 0 -25.861z"></path>
                  </svg>
                Utforsk statistikken
            </a>
          
          </a>
  </section>
</article>

<style lang="scss">
  .sa-koronastripe-v2 {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    border: 1px solid #ddd;
    border-radius: 3px;
    margin: 0 12px;
    background-color: #fff;
    @include desktop {
      margin: 0;
    }
    .row {
      display: flex;
      flex-direction: row;
      width: 100%;

      &.center {
          align-items: baseline;
          justify-content: center;
          flex-direction: row;
      }

      .col {
        display: flex;
        align-items: center;
        height: 100%;
        
        &.stat {
          padding: 0 8px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-start;
          

          &.center {
            justify-content: center;
          }
          
        }
        &.group-right {
            margin-left: auto;          
        }
      
        &.col-link {
            &:not(:last-child) {
            border-right: 1px solid #ddd;
          }
        }
        
        .link {
          margin: 0;
          padding: 6px 8px;
          white-space: nowrap;
          &-btn {
              display: inline-flex;
              align-items: center;
              padding: 16px 8px;
              cursor: pointer;
              &:hover {
                  .icon {
                      fill: color('dark');
                  }
                }
              .icon {
                  margin-right: 4px;
                  height: 12px;
                  width: 12px;
                  fill: color('gray');
                
              }
          }
          
        }
      }

      &.top {
        background-color: #f1f1f1;
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 2px 0;
        .title {
          margin: 0;
          padding: 0 8px;
          margin-right: 20px;
          font-weight: 600;
          @include desktop {
            margin-right: 0;
          }
        }
      }

      &.stat {
        position: relative;
        padding: 6px 0;
        .row {
          justify-content: center;
        }
        .col {
          flex-direction: column;
          &:not(:last-child) {
            padding-right: 8px;
          }
        }
        .title {
          margin: 0;
          font-weight: 600;
          font-size: 12px;
          color: #545454;
          white-space: nowrap;
        }
        .subtitle {
          margin: 0;
          font-weight: 400;
          font-size: 12px;
          color: #545454;
          white-space: nowrap;
        }
        .value {
          font-weight: 600;
          white-space: nowrap;
          margin: 0 3px 0 0;
        }
        .label {
          margin: 0 10px 0 0;
          font-size: 12px;
          white-space: nowrap;
        }
      }
      .col.stat:not(:last-child) {
        border-right: 1px solid #ddd;
      }
      .col.stat:last-child {
        margin-right: 10px;
      }

      .row-scroll {
        text-decoration: none;
        display: flex;
        flex-direction: row;
        width: 100%;
        overflow-x: scroll;
        scrollbar-width: none;
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
          display: none;
        }
      }
      .fade-right {
        &:before {
          display: inline-block;
          content: "";
          position: absolute;
          right: 0;
          bottom: 0;
          height: 100%;
          width: 40px;
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 1) 100%
          );
          pointer-events: none;
          z-index: 1;
        }
        &-top:before {
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(241, 241, 241, 1) 100%
          );
          @media only screen and (min-width: 450px) {
            display: none;
          }
        }
      }
    }
  }
</style>
